var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mobile-footer",domProps:{"innerHTML":_vm._s(_vm.dataSourceByDataType)}})}
var staticRenderFns = []

export { render, staticRenderFns }